import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import VideoPoly from '../../images/polygons/video.svg';
import YellowDotPoly from '../../images/polygons/yellow-dot.svg';
import YellowTriPoly from '../../images/polygons/yellow-triangle.svg';
import BlueDotPoly from '../../images/polygons/blue-dot.svg';
import BluePoly from '../../images/polygons/blue-poly.svg';
import CirclyPoly from '../../images/polygons/half-circle.svg';
import LightPoly from '../../images/polygons/light-poly.svg';
import LightTriPoly from '../../images/polygons/light-tri.svg';

const useStyles = makeStyles(theme => ({
  polies: {
    position: 'absolute',
  },
  videoPy: {
    right: '-4%',
    top: '30%',
    [theme.breakpoints.down('xs')]: {
      right: 0,
    },
  },
  yellowDotPy: {
    right: '-4%',
    top: '45%',
    [theme.breakpoints.down('xs')]: {
      right: 0,
    },
  },
  yellowTriPy: {
    bottom: '15%',
    right: '-4%',
    [theme.breakpoints.down('xs')]: {
      right: 0,
    },
  },
  lightTriPy: {
    right: '26%',
    top: '7%',
    [theme.breakpoints.down('xs')]: {
      right: 0,
    },
  },
  bluePy: {
    left: '43%',
    bottom: '10%',
  },
  blueDotPy: {
    left: '35%',
    top: '-5px',
    zIndex: 0,
  },
  circlePy: {
    right: '41%',
    zIndex: 9,
  },
  lightPy: {
    left: '18%',
    top: '35%',
  },
}));

function Polygons() {
  const classes = useStyles();
  return (
    <>
      <img
        src={VideoPoly}
        className={ClassNames(classes.polies, classes.videoPy)}
        alt=""
      />
      <img
        src={YellowDotPoly}
        className={ClassNames(classes.polies, classes.yellowDotPy)}
        alt=""
      />
      <img
        src={YellowTriPoly}
        className={ClassNames(classes.polies, classes.yellowTriPy)}
        alt=""
      />
      <img
        src={CirclyPoly}
        className={ClassNames(classes.polies, classes.circlePy)}
        alt=""
      />
      <img
        src={BlueDotPoly}
        className={ClassNames(classes.polies, classes.blueDotPy)}
        alt=""
      />
      <img
        src={BluePoly}
        className={ClassNames(classes.polies, classes.bluePy)}
        alt=""
      />
      <img
        src={LightTriPoly}
        className={ClassNames(classes.polies, classes.lightTriPy)}
        alt=""
      />
      <img
        src={LightPoly}
        className={ClassNames(classes.polies, classes.lightPy)}
        alt=""
      />
    </>
  );
}

export default Polygons;
